import React from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { UserSchema } from "../../schema/UserSchema";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import Select from "../../helpers/FormikHelper/Select";
import userServices from "../../services/user.services";
import { toast } from 'react-toastify';
import { CenterSchema } from "../../schema/CenterSchema";

const initialValues = {
    email: '',
    password: '',
    fullName: '',
    mobile: '',
    address: '',
    center_id:'',
    password: '',
    gender: 'male'
}

const CenterUserForm = ({ toggle, isAddMode, getAllCenterUsers, selectedRow,centers }) => {  
     const savedValues = {
        email: selectedRow?.email,
        password: selectedRow?.password,
        fullName: selectedRow?.name,
        mobile: selectedRow?.mobile,
        address: selectedRow?.address,
        center_id: selectedRow?.center_id,
        gender: selectedRow?.gender
    }
    const onSubmit = async (values) => {
        const reqBody = {
            name: values.fullName,
            gender: values.gender,
            mobile: values.mobile,
            email: values.email,
            user_type_id: 2,
            address: values.address,
            center_id: values.center_id,
            password: values.password

        }
       if(isAddMode==='Add'){
        const result = await userServices.createUser(reqBody);
        if (result.data.status === true) {
            // actions.resetForm();
            getAllCenterUsers()
            toggle()
            toast.success('User registration successfully', { toastId: 'registration_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
        }
    }else{
        const reqBody = {
            name: values.fullName,
            gender: values.gender,
            mobile: values.mobile,
            email: values.email,
            address: values.address,
            center_id: values.center_id,
            password: values.password

        }
        const result = await userServices.updateUserById(selectedRow?._id,reqBody)
        if (result.data.status === true) {
            // actions.resetForm();
            getAllCenterUsers()
            toggle()
            toast.success(result.data.message, { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode==='Add'?initialValues:savedValues}
                validationSchema={CenterSchema('ADD_CENTER_USER')}
                onSubmit={onSubmit}
                enableReinitialize
            >
               {({  setFieldValue, values }) => (  <Form>
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add User' : 'Update User'}</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >
                            <div className="col-md-12">
                                    <label htmlFor="center_id" className="form-label">
                                        Center Name
                                    </label>
                                    <Field as='select' className='form-select' id="center_id" name="center_id" >
                                        <option disabled value="">Select Center</option>
                                        {
                                            centers.map((e, key) => {
                                                return <option key={key} value={e._id}>{e.center_name}</option>;
                                            })
                                        }
                                    </Field>
                                    <ErrorMessage name="center_id" component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="fullName" className="form-label">
                                        Full Name
                                    </label>
                                    <Field type="text" className="form-control" id="fullName" name='fullName'
                                    />
                                    <ErrorMessage name='fullName' component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="mobile" className="form-label">
                                        Mobile No
                                    </label>
                                    <Field type="text" className="form-control" id="mobile" name='mobile'  maxLength="10"
                                    />
                                    <ErrorMessage name='mobile' component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="email" className="form-label">
                                        E-Mail
                                    </label>
                                    <Field type="email" className="form-control" id="email" name='email'
                                    />
                                    <ErrorMessage name='email' component={TextError} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="password" className="form-label">
                                        Password
                                    </label>
                                    <Field type="password" className="form-control" id="password" name='password' disabled={isAddMode==='Add'?false:true}/>
                                    <ErrorMessage name='password' component={TextError} />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="address" className="form-label">
                                        address
                                    </label>
                                    <Field
                                        className="form-control"
                                        id="address"
                                        // placeholder="Address..."
                                        name='address'
                                        type='text'
                                    />
                                    <ErrorMessage name="address" component={TextError} />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="mobile" className="form-label">Gender</label><br/>
                                    <label htmlFor="male" className="me-3">
                                        Male
                                        <Field type="radio" name="gender" id="male" value="male" className="ms-2 form-check-input"  />
                                    </label>
                                    <label htmlFor="female" className="">
                                        Female
                                        <Field type="radio" name="gender" id="female" value="female" className="ms-2 form-check-input" />
                                    </label>
                                </div>   
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                        {isAddMode === "Add" ? "Save" : "Update"}
                        </button>
                    </ModalFooter>
                </Form>
 )}
            </Formik>
        </React.Fragment>
    );
}

export default CenterUserForm;